import { ITransitionProperty } from '@src/slide/domain/ui-model/element-modeles/property/transition/interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ITransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { getChangedPart } from '@src/slide/infrastructure/module/independent/object/object-path';
import { arrApplyNull } from '@src/slide/infrastructure/module/independent/object/arr-apply-null';
import {
    changeArrAppendToSetOrModify,
} from '@src/slide/infrastructure/module/independent/object/arr-append-to-set-or-modify';

export default class TransitionProperty implements ITransitionProperty {
    public constructor(private slideModel: ISlideModel) {}

    public removeTransition() {
        this.slideModel.removeProps({ transition: null });
    }

    public updateProps(transition: Partial<ITransition> | null) {
        if (!this.slideModel.sdkData) return; // 解绑后为null

        const uiModel = {
            props: { transition },
            parent: this.slideModel.parent,
        };
        const slideSdkData = this.slideModel.sdkData;
        const updateSdkData = this.slideModel.prepareSDKData(uiModel as unknown as Partial<IBaseModel>);

        const changedProps = getChangedPart(((slideSdkData as any).store ?? slideSdkData).data, updateSdkData);
        if (!Object.keys(changedProps).length) {
            return;
        }
        // 中台的对象属性如果是数组，想要删除的话只能置为空数组，用 null 无法删除
        arrApplyNull(((slideSdkData as any).store ?? slideSdkData).data, updateSdkData);
        // 中台默认传递array是append模式，上层纠正为set或者modify模式
        changeArrAppendToSetOrModify(updateSdkData);

        slideSdkData?.api?.updateTransition(updateSdkData?.transition);
    }
}
